import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { ObservableQuery } from '@apollo/client';
import { Store } from '@ngrx/store';
import { LoadMissingConsents } from '../../+state';

interface ErrorResponse {
  errors?: { message?: string }[];
}

export function missingConsentInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const store = inject(Store);
  const router = inject(Router);
  return next(req).pipe(
    tap((event: HttpEvent<ObservableQuery.Result<unknown>>) => {
      if (event.type === HttpEventType.Response) {
        const body = event?.body as ErrorResponse;
        const hasMissingConsent = body?.errors?.some(error =>
          error?.message?.includes('MANDATORY_CONSENT_FOR_USER_IS_MISSING')
        );
        if (hasMissingConsent) {
          store.dispatch(LoadMissingConsents());
          void router.navigate(['consent']);
        }
      }
    })
  );
}
